import { ContentTranslation } from '../../../models/content-translation.model';

export class Message {
  public userId: string;
  public senderName: string;
  public text: string;
  public textTranslation?: ContentTranslation | null;
  public time: string;

  constructor(userId: string, senderName: string, text: string, time: string) {
    this.userId = userId;
    this.senderName = senderName;
    this.text = text;
    this.time = time;
  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/operating-standard/chat/message.model.ts